// extracted by mini-css-extract-plugin
module.exports = {"main":"errorScreen_main__1Z6Lo","btn":"errorScreen_btn__3YbXV"};